import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useOperateHiChatSessionMessages } from '@/hooks';
import message from 'antd/es/message';

import { request, L2TxReqParams, toastError } from '@/utils';

import { HiMessage, HiOfferInfo, HiSession } from '../types';

export function useChargeOffer() {
  const { putMessageOnSession } = useOperateHiChatSessionMessages();

  return useMutation(
    async (params: {
      offer_id: HiOfferInfo['id'];
      message_id: HiMessage['id'];
      session_id: HiSession['id'];
    }) => {
      const result = await request
        .put<HiOfferInfo>('/hi/offer/charge', {
          id: params.offer_id,
        })
        .then(
          () => {
            message.success('opened');
          },
          err_msg => {
            message.warning(err_msg);
          },
        );

      await request
        .get<HiMessage>('/hi/message', {
          id: params.message_id,
          session_id: params.session_id,
        })
        .then(message => {
          putMessageOnSession(params.session_id, [message]);
        });

      return result;
    },
  );
}

export function useOfferBoost(id: string) {
  const { t } = useTranslation();
  // const { putMessageOnSession } = useOperateHiChatSessionMessages();

  return useMutation(
    (tx: L2TxReqParams) => {
      return request
        .post<{ is_success: boolean }>('/hi/offer/boost', {
          id,
          tx,
        })
        .then(data => {
          // putMessageOnSession(data.session_id, [data]);
          return data;
        });
    },
    {
      onSuccess({ is_success }) {
        if (is_success) {
          message.success(t('BoostTipModal.boostSuccess'));
        } else {
          toastError('Failed');
        }
      },
      onError(err: any) {
        toastError(err);
      },
    },
  );
}
